export const green_main_color = '#096418'
export const green_secondary_color = '#14B227'

export const red_main_color = '#960B0B'
export const red_secondary_color = '#D11010'

export const background_color = '#ffffff'
export const shadow_color = '#BABFBB'
export const blue_background = "#0a1e27"